import RequestBuilder, { comparisonTypes } from 'Resources/RequestBuilder';
import Mail from 'App/resources/Model/Mail';
import MailResource from 'Resources/Mail';
import { ListViewFilter } from 'App/resources/AllIWant';
import MailAttributes from 'App/babel/attributes/MailAttributes';
import openModal from 'App/services/Modal';
import { getConfig } from 'App/helpers/filterHelperInstances';

export default async function createMailCampaign(
	filters: {
		[filterName: string]: ListViewFilter;
	},
	allSelected: boolean,
	selectedIds: number[],
	entityType: string
) {
	let mailFilters: { [key: string]: any };
	if (entityType === 'mail') {
		const rb = new RequestBuilder();
		rb.addFilter(MailAttributes.id, comparisonTypes.Equals, selectedIds);
		const { data } = await MailResource.find(rb.build());
		const contactIds = data.map((mail: Mail) => mail.contact?.id);
		// getConfig is typed nullable; 'Id' always resolves for contact, and a missing config threw
		// here before the conversion too.
		const idFilters = getConfig('Id', 'contact') as unknown as { value: unknown; comparisonType: string };
		idFilters.value = contactIds ?? [];
		idFilters.comparisonType = 'Equals';
		mailFilters = { Id: idFilters };
	} else {
		if (!allSelected && !filters.MailCampaignFilters) {
			// getConfig is typed nullable; 'Id' always resolves for contact, and a missing config threw
			// here before the conversion too.
			const idFilters = getConfig('Id', 'contact') as unknown as { value: unknown; comparisonType: string };
			idFilters.value = selectedIds;
			idFilters.comparisonType = 'Equals';
			mailFilters = { Id: idFilters };
		} else {
			mailFilters = filters;
		}
	}
	openModal('CreateGroupMail', { filters: mailFilters });
}
